import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import ProtectedRoute from './components/common/ProtectedRoute';
import Loader from './components/common/Loader';
import { useAuth } from './context/AuthContext';

// Public pages
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderSuccessPage from './pages/OrderSuccessPage';
import VendorsPage from './pages/VendorsPage';
import VendorStorePage from './pages/VendorStorePage';
import BecomeVendorPage from './pages/BecomeVendorPage';

// Buyer pages
import MyOrdersPage from './pages/buyer/MyOrdersPage';
import OrderDetailPage from './pages/buyer/OrderDetailPage';
import WishlistPage from './pages/buyer/WishlistPage';
import ProfilePage from './pages/buyer/ProfilePage';

// Vendor pages
import VendorDashboard from './pages/vendor/VendorDashboard';
import VendorProducts from './pages/vendor/VendorProducts';
import AddProduct from './pages/vendor/AddProduct';
import VendorOrders from './pages/vendor/VendorOrders';
import VendorSettings from './pages/vendor/VendorSettings';

// Admin pages
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminVendors from './pages/admin/AdminVendors';
import AdminOrders from './pages/admin/AdminOrders';
import AdminUsers from './pages/admin/AdminUsers';
import AdminSettings from './pages/admin/AdminSettings';
import AdminCategories from './pages/admin/AdminCategories';

import './styles/global.css';

function App() {
  const location = useLocation();
  const { loading } = useAuth();

  if (loading) return <Loader />;

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />

      <main style={{ flex: 1, padding:'15px'}}>
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            {/* Public */}
            <Route path="/"             element={<HomePage />} />
            <Route path="/login"        element={<LoginPage />} />
            <Route path="/register"     element={<RegisterPage />} />
            <Route path="/products"     element={<ProductsPage />} />
            <Route path="/products/:id" element={<ProductDetailPage />} />
            <Route path="/vendors"      element={<VendorsPage />} />
            <Route path="/vendors/:id"  element={<VendorStorePage />} />
            <Route path="/vendor/apply" element={<BecomeVendorPage />} />
            <Route path="/cart"         element={<CartPage />} />
            <Route path="/checkout"     element={<ProtectedRoute roles={['buyer', 'vendor', 'admin']}><CheckoutPage /></ProtectedRoute>} />
            <Route path="/order-success/:orderId" element={<ProtectedRoute roles={['buyer', 'vendor', 'admin']}><OrderSuccessPage /></ProtectedRoute>} />

            {/* Buyer */}
            <Route path="/profile"    element={<ProtectedRoute roles={['buyer','vendor','admin']}><ProfilePage /></ProtectedRoute>} />
            <Route path="/orders"     element={<ProtectedRoute roles={['buyer','vendor','admin']}><MyOrdersPage /></ProtectedRoute>} />
            <Route path="/orders/:id" element={<ProtectedRoute roles={['buyer','vendor','admin']}><OrderDetailPage /></ProtectedRoute>} />
            <Route path="/wishlist"   element={<ProtectedRoute roles={['buyer','vendor','admin']}><WishlistPage /></ProtectedRoute>} />

            {/* Vendor */}
            <Route path="/vendor/dashboard"         element={<ProtectedRoute roles={['vendor']}><VendorDashboard /></ProtectedRoute>} />
            <Route path="/vendor/products"          element={<ProtectedRoute roles={['vendor']}><VendorProducts /></ProtectedRoute>} />
            <Route path="/vendor/products/add"      element={<ProtectedRoute roles={['vendor']}><AddProduct /></ProtectedRoute>} />
            <Route path="/vendor/products/edit/:id" element={<ProtectedRoute roles={['vendor']}><AddProduct /></ProtectedRoute>} />
            <Route path="/vendor/orders"            element={<ProtectedRoute roles={['vendor']}><VendorOrders /></ProtectedRoute>} />
            <Route path="/vendor/settings"          element={<ProtectedRoute roles={['vendor']}><VendorSettings /></ProtectedRoute>} />

            {/* Admin */}
            <Route path="/admin/dashboard"  element={<ProtectedRoute roles={['admin']}><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/vendors"    element={<ProtectedRoute roles={['admin']}><AdminVendors /></ProtectedRoute>} />
            <Route path="/admin/orders"     element={<ProtectedRoute roles={['admin']}><AdminOrders /></ProtectedRoute>} />
            <Route path="/admin/users"      element={<ProtectedRoute roles={['admin']}><AdminUsers /></ProtectedRoute>} />
            <Route path="/admin/categories" element={<ProtectedRoute roles={['admin']}><AdminCategories /></ProtectedRoute>} />
            <Route path="/admin/settings"   element={<ProtectedRoute roles={['admin']}><AdminSettings /></ProtectedRoute>} />
            <Route path="/admin/products"   element={<ProtectedRoute roles={['admin']}><div className="container section">Admin Products (coming soon)</div></ProtectedRoute>} />
            <Route path="/admin/returns"    element={<ProtectedRoute roles={['admin']}><div className="container section">Admin Returns (coming soon)</div></ProtectedRoute>} />
            <Route path="/admin/withdrawals" element={<ProtectedRoute roles={['admin']}><div className="container section">Admin Withdrawals (coming soon)</div></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AnimatePresence>
      </main>

      <Footer />
    </div>
    </GoogleOAuthProvider>
  );
}

export default App;
